<script lang="ts">
  import * as Card from "$lib/components/ui/card";
  import AddressValue from "$src/presentation/core/address-value.svelte";
  import { UserCircle, MapPin, Mail, Phone, CreditCard } from "lucide-svelte";
  import { languageCode } from "$src/presentation/core/languageCode";
  import { getTranslation } from "$src/presentation/core/TranslatedTextUtils";
  import { getCustomerInfo } from "$src/domain/customers/utils/customer-info-utils";
  import { type Customer } from "$src/domain/customers/Customer";

  export let customer: Customer;
</script>


<Card.Root class="bg-background rounded-lg  p-4 md:max-w-xs mx-auto">
  <Card.Header class="flex flex-row items-center mb-1">
    <div class="rounded-full bg-secondary p-2">
      <UserCircle class="text-secondary-foreground w-6 h-6" />
    </div>
    <div class="ml-4">
      <div class="text-lg font-semibold">{getCustomerInfo(customer)}</div>
      <div class="text-sm font-semibold">
        {getTranslation(customer.customerType.translations, $languageCode)}
      </div>
    </div>
  </Card.Header>
  <Card.Content class="flex flex-col text-sm text-muted-foreground">
    <div class="border-t pt-4">
      <div class="flex items-start mb-2">
        <MapPin class="w-4 h-4 mr-2" />
        <div>
          <div>
            <AddressValue value={customer.billingAddress} />
          </div>
        </div>
      </div>
      <div class="flex items-center mb-2">
        <Mail class="w-4 h-4 mr-2 " />
        <a
          href="mailto:{customer.email}"
          class="text-sm hover:text-secondary-foreground"
        >
          {customer.email}
        </a>
      </div>
      <div class="flex items-center mb-2">
        <Phone class="w-4 h-4 mr-2" />
        <p class="text-sm">{customer.phoneNumber1}</p>
      </div>
      <!-- <div class="flex items-center">
        <p class="text-sm">N° TVA : BE 123.456.789</p>
      </div> -->
    </div>
  </Card.Content>
</Card.Root>
